// Better Auth supplies its own cancellation signal for session requests. Its
// fetch timeout is skipped in that case, so preserve cancellation and bound I/O.
const fetchWithTimeout = async (input, options = {}, fetchImplementation = fetch) => {
    const controller = new AbortController();
    const originalSignal = options.signal || input?.signal;
    const cancel = () => controller.abort(originalSignal?.reason);
    if (originalSignal?.aborted) cancel();
    else originalSignal?.addEventListener('abort', cancel, { once: true });
    const timer = setTimeout(() => controller.abort(), 30000);
    try {
        return await fetchImplementation(input, { ...options, signal: controller.signal });
    } finally {
        clearTimeout(timer);
        originalSignal?.removeEventListener('abort', cancel);
    }
};

module.exports = fetchWithTimeout;
